/* Handmade at Heart reviews. Only the public API's approved reviews are displayed. */
(function () {
  'use strict';
  if (window.HahReviews) { window.HahReviews.mountAll(document); return; }
  var sequence = 0;
  var MAX_PHOTOS = 3, MAX_PHOTO_BYTES = 2 * 1024 * 1024;
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function button(text, className) {
    var node = el('button', className || 'hah-reviews__button', text);
    node.type = 'button';
    return node;
  }
  function key() {
    return window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() :
      'review-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }
  function whole(value) { return Number.isSafeInteger(value) && value >= 0; }
  function stars(rating) {
    var node = el('span', 'hah-reviews__stars', '★★★★★');
    node.style.setProperty('--hah-review-fill', Math.max(0, Math.min(100, rating * 20)) + '%');
    node.setAttribute('role', 'img');
    node.setAttribute('aria-label', rating.toFixed(1) + ' out of 5 stars');
    return node;
  }
  function photoUrl(value, apiUrl) {
    try {
      var url = new URL(value, apiUrl.href), prefix = '/shopify-app/api/reviews/media/';
      var filename = url.pathname.slice(prefix.length);
      return typeof value === 'string' && url.protocol === 'https:' && url.origin === apiUrl.origin &&
        !url.username && !url.password && url.pathname.indexOf(prefix) === 0 &&
        /^[a-zA-Z0-9][a-zA-Z0-9._-]*$/.test(filename) ? url.href : null;
    } catch (_) { return null; }
  }
  function validatePage(data) {
    var summary = data && data.summary;
    if (!summary || !whole(summary.count) || !whole(data.total) || !whole(data.page) || data.page < 1 ||
        !whole(data.pages) || !Array.isArray(data.items) || !summary.distribution ||
        (summary.count > 0 && (!Number.isFinite(summary.average) || summary.average < 1 || summary.average > 5))) {
      throw new Error('Reviews could not be loaded. Please try again.');
    }
    for (var rating = 1; rating <= 5; rating++) {
      if (!whole(summary.distribution[String(rating)])) throw new Error('Reviews could not be loaded. Please try again.');
    }
    if (data.items.some(function (item) {
      return !item || !Number.isInteger(item.rating) || item.rating < 1 || item.rating > 5 ||
        typeof item.name !== 'string' || typeof item.body !== 'string' || !Array.isArray(item.photos);
    })) throw new Error('Reviews could not be loaded. Please try again.');
    return data;
  }
  function errorMessage(error, fallback) {
    return error && error.name === 'AbortError' ? 'The request took too long. Please try again.' :
      error && error.message ? error.message : fallback;
  }
  async function request(url, options, timeout, controller) {
    var timer = window.setTimeout(function () { controller.abort(); }, timeout);
    try {
      var response = await fetch(url, Object.assign({ credentials: 'omit', mode: 'cors', signal: controller.signal }, options));
      var data;
      try { data = await response.json(); } catch (_) { throw new Error('The review service is unavailable. Please try again.'); }
      if (!response.ok) {
        var message = data && (typeof data.message === 'string' ? data.message : typeof data.detail === 'string' ? data.detail : data.error);
        if (response.status === 429) message = 'Too many requests. Please wait a moment and try again.';
        throw new Error(typeof message === 'string' ? message.slice(0, 500) : 'The review service is unavailable. Please try again.');
      }
      return data;
    } finally { window.clearTimeout(timer); }
  }
  function field(parent, id, label, tag, options) {
    var wrapper = el('div', 'hah-reviews__field');
    var labelNode = el('label', '', label); labelNode.htmlFor = id;
    var input = el(tag || 'input'); input.id = id;
    Object.keys(options || {}).forEach(function (name) { input[name] = options[name]; });
    wrapper.append(labelNode, input); parent.appendChild(wrapper);
    return input;
  }
  async function compressPhoto(file) {
    if (!/^image\/(jpeg|png|webp)$/.test(file.type)) throw new Error('Choose JPG, PNG or WebP photos.');
    if (file.size > 25 * 1024 * 1024) throw new Error('Please choose a photo smaller than 25 MB.');
    var bitmap, objectUrl;
    try {
      if (typeof createImageBitmap === 'function') bitmap = await createImageBitmap(file);
      else {
        objectUrl = URL.createObjectURL(file);
        bitmap = await new Promise(function (resolve, reject) {
          var image = new Image();
          image.onload = function () { resolve(image); };
          image.onerror = function () { reject(new Error('This photo could not be opened. Please choose another.')); };
          image.src = objectUrl;
        });
      }
      var width = bitmap.naturalWidth || bitmap.width, height = bitmap.naturalHeight || bitmap.height;
      if (!width || !height || width * height > 60000000) throw new Error('This photo is too large to process. Please choose a smaller copy.');
      var scale = Math.min(1, 1600 / Math.max(width, height));
      var canvas = document.createElement('canvas');
      canvas.width = Math.max(1, Math.round(width * scale)); canvas.height = Math.max(1, Math.round(height * scale));
      var context = canvas.getContext('2d');
      if (!context) throw new Error('Photos could not be prepared in this browser. You can submit your review without them.');
      context.fillStyle = '#ffffff'; context.fillRect(0, 0, canvas.width, canvas.height);
      context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      for (var quality of [0.88, 0.76, 0.62, 0.45]) {
        var blob = await new Promise(function (resolve) { canvas.toBlob(resolve, 'image/jpeg', quality); });
        if (blob && blob.size < MAX_PHOTO_BYTES) {
          var dataUrl = await new Promise(function (resolve, reject) {
            var reader = new FileReader(); reader.onload = function () { resolve(reader.result); };
            reader.onerror = function () { reject(new Error('This photo could not be prepared. Please choose another.')); };
            reader.readAsDataURL(blob);
          });
          return { name: (file.name.replace(/\.[^.]+$/, '').slice(0, 90) || 'review-photo') + '.jpg', data_url: dataUrl };
        }
      }
      throw new Error('This photo could not be reduced below 2 MB. Please choose a smaller copy.');
    } finally {
      if (bitmap && bitmap.close) bitmap.close();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    }
  }
  function mount(root) {
    if (root.dataset.hahReviewsReady === 'true') return;
    var productId = root.dataset.productId, apiUrl;
    try { apiUrl = new URL(root.dataset.apiUrl); } catch (_) { return; }
    if (!/^\d+$/.test(productId || '') || apiUrl.protocol !== 'https:') return;
    var content = root.querySelector('[data-hah-reviews-content]');
    if (!content) return;
    root.dataset.hahReviewsReady = 'true';
    var prefix = 'hah-review-' + productId + '-' + (++sequence), anchor = '#' + root.id;
    var state = { page: 1, requestedPage: 1, pages: 0, sort: 'newest', photos: [], loading: false, processing: false, submitting: false, submitted: false, serial: 0, signature: '', key: '', readController: null, postController: null, destroyed: false };
    var invitationToken = new URL(window.location.href).searchParams.get('review_token') || '';
    var summary = el('div', 'hah-reviews__summary'); summary.setAttribute('data-hah-reviews-summary', ''); summary.hidden = true;
    var actionRow = el('div', 'hah-reviews__actions');
    var writeButton = button('Write a review'); actionRow.appendChild(writeButton);
    var readStatus = el('p', 'hah-reviews__status'); readStatus.setAttribute('role', 'status'); readStatus.setAttribute('data-hah-reviews-status', '');
    var retry = button('Try again', 'hah-reviews__button hah-reviews__button--secondary'); retry.hidden = true;
    var toolbar = el('div', 'hah-reviews__toolbar'); toolbar.hidden = true;
    var totalLabel = el('p');
    var sortLabel = el('label', 'hah-reviews__sort', 'Sort by ');
    var sort = el('select'); sort.setAttribute('aria-label', 'Sort customer reviews');
    [['newest', 'Most recent'], ['highest', 'Highest rating'], ['lowest', 'Lowest rating']].forEach(function (entry) {
      var option = el('option', '', entry[1]); option.value = entry[0]; sort.appendChild(option);
    });
    sortLabel.appendChild(sort); toolbar.append(totalLabel, sortLabel);
    var list = el('div', 'hah-reviews__list'); list.setAttribute('data-hah-reviews-list', ''); list.tabIndex = -1; list.setAttribute('aria-label', 'Customer reviews');
    var pagination = el('nav', 'hah-reviews__pagination'); pagination.setAttribute('aria-label', 'Review pages'); pagination.hidden = true;
    var previous = button('Previous', 'hah-reviews__button hah-reviews__button--secondary'); previous.setAttribute('data-hah-reviews-prev', '');
    var next = button('Next', 'hah-reviews__button hah-reviews__button--secondary'); next.setAttribute('data-hah-reviews-next', '');
    var pageLabel = el('span'); pagination.append(previous, pageLabel, next);
    var formPanel = el('div', 'hah-reviews__form-panel'); formPanel.hidden = true;
    var formHeading = el('h3', '', 'Share your experience'); formHeading.id = prefix + '-form-heading';
    var form = el('form', 'hah-reviews__form'); form.setAttribute('data-hah-reviews-form', ''); form.setAttribute('aria-labelledby', formHeading.id);
    var intro = el('p', 'hah-reviews__muted', 'Your email stays private. Reviews are checked before they appear here.');
    var ratingField = el('fieldset', 'hah-reviews__rating-field'); ratingField.appendChild(el('legend', '', 'Your rating'));
    var ratingChoices = el('div', 'hah-reviews__rating-choices');
    for (var score = 1; score <= 5; score++) {
      var choice = el('label', 'hah-reviews__rating-choice');
      var radio = el('input'); radio.type = 'radio'; radio.name = 'rating'; radio.value = String(score); radio.required = true;
      radio.setAttribute('aria-label', score + (score === 1 ? ' star' : ' stars'));
      choice.append(radio, el('span', '', score + ' ★')); ratingChoices.appendChild(choice);
    }
    ratingField.appendChild(ratingChoices);
    var fields = el('div', 'hah-reviews__fields');
    var name = field(fields, prefix + '-name', 'Name', 'input', { type: 'text', name: 'name', required: true, maxLength: 80, autocomplete: 'name' });
    var email = field(fields, prefix + '-email', 'Email (not published)', 'input', { type: 'email', name: 'email', required: true, maxLength: 254, autocomplete: 'email' });
    var title = field(form, prefix + '-title', 'Review title (optional)', 'input', { type: 'text', name: 'title', maxLength: 120 });
    var body = field(form, prefix + '-body', 'Your review', 'textarea', { name: 'body', required: true, maxLength: 5000, rows: 5 });
    form.prepend(ratingField, fields);
    var fileWrap = el('div', 'hah-reviews__field');
    var fileLabel = el('label', '', 'Add photos (optional)'); fileLabel.htmlFor = prefix + '-photos';
    var file = el('input'); file.type = 'file'; file.id = prefix + '-photos'; file.accept = 'image/jpeg,image/png,image/webp'; file.multiple = true;
    var fileHint = el('p', 'hah-reviews__muted', 'Up to 3 JPG, PNG or WebP photos. Photos are resized before uploading.'); fileHint.id = prefix + '-photo-hint'; file.setAttribute('aria-describedby', fileHint.id);
    var previews = el('div', 'hah-reviews__photo-previews'); previews.setAttribute('data-hah-reviews-photos', '');
    fileWrap.append(fileLabel, file, fileHint, previews); form.appendChild(fileWrap);
    var honeyWrap = el('div', 'hah-reviews__honeypot'); honeyWrap.setAttribute('aria-hidden', 'true');
    var website = field(honeyWrap, prefix + '-website', 'Leave this field empty', 'input', { type: 'text', name: 'website', tabIndex: -1, autocomplete: 'off' }); form.appendChild(honeyWrap);
    var submitStatus = el('p', 'hah-reviews__status'); submitStatus.setAttribute('role', 'status'); submitStatus.setAttribute('data-hah-reviews-submit-status', '');
    var formActions = el('div', 'hah-reviews__form-actions');
    var submit = button('Submit review'); submit.type = 'submit';
    var cancel = button('Cancel', 'hah-reviews__button hah-reviews__button--secondary'); formActions.append(submit, cancel);
    form.append(submitStatus, formActions); formPanel.append(formHeading, intro, form);
    var confirmation = el('div', 'hah-reviews__confirmation'); confirmation.hidden = true; confirmation.setAttribute('role', 'status');
    formPanel.appendChild(confirmation);
    content.replaceChildren(summary, actionRow, formPanel, readStatus, retry, toolbar, list, pagination);
    function formMessage(message, failed) {
      submitStatus.textContent = message;
      submitStatus.classList.toggle('is-error', !!failed);
      submitStatus.setAttribute('role', failed ? 'alert' : 'status');
    }
    function syncForm() {
      var busy = state.submitting || state.processing;
      form.querySelectorAll('input, textarea, button').forEach(function (input) { input.disabled = busy; });
      file.disabled = busy || state.photos.length >= MAX_PHOTOS;
      submit.textContent = state.submitting ? 'Submitting…' : state.processing ? 'Preparing photos…' : 'Submit review';
      form.setAttribute('aria-busy', String(busy));
    }
    function openForm(focus) {
      formPanel.hidden = false;
      if (focus) {
        formPanel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        var first = state.submitted ? confirmation : form.querySelector('[name="rating"]');
        if (state.submitted) confirmation.tabIndex = -1;
        first.focus({ preventScroll: true });
      }
    }
    function updateHeader(data) {
      document.querySelectorAll('[data-hah-native-review-summary]').forEach(function (host) {
        var owner = host.dataset.productId || (host.closest('[data-product-id]') || {}).dataset?.productId;
        if (owner && owner !== productId) return;
        var link = host.tagName === 'A' ? host : el('a', 'hah-product-rating');
        link.replaceChildren(); link.href = anchor; link.setAttribute('data-hah-review-link', '');
        if (data.count > 0) {
          link.append(stars(data.average), el('span', '', data.average.toFixed(1) + ' (' + data.count.toLocaleString('en') + (data.count === 1 ? ' review)' : ' reviews)')));
          link.setAttribute('aria-label', data.average.toFixed(1) + ' out of 5 from ' + data.count + ' reviews. Read customer reviews.');
        } else {
          link.textContent = 'Write the first review'; link.setAttribute('aria-label', 'Write the first review');
        }
        link.onclick = function (event) {
          if (data.count === 0 || invitationToken) { event.preventDefault(); openForm(true); }
        };
        if (link !== host) host.replaceChildren(link);
        host.hidden = false;
      });
    }
    function renderSummary(data) {
      summary.replaceChildren(); summary.hidden = false;
      if (data.count === 0) {
        var empty = el('div', 'hah-reviews__empty');
        empty.append(el('h3', '', 'Be the first to share your experience'), el('p', '', 'Have this item? Tell others what you think and share a photo.'));
        summary.appendChild(empty);
      } else {
        var aggregate = el('div', 'hah-reviews__aggregate');
        aggregate.append(el('strong', 'hah-reviews__average', data.average.toFixed(1)), stars(data.average), el('p', '', 'Based on ' + data.count.toLocaleString('en') + (data.count === 1 ? ' review' : ' reviews')));
        var distribution = el('div', 'hah-reviews__distribution'); distribution.setAttribute('aria-label', 'Rating distribution');
        for (var score = 5; score >= 1; score--) {
          var count = data.distribution[String(score)], row = el('div', 'hah-reviews__distribution-row');
          row.setAttribute('aria-label', score + ' stars: ' + count + (count === 1 ? ' review' : ' reviews'));
          var track = el('span', 'hah-reviews__bar'), fill = el('span'); fill.style.width = Math.min(100, count * 100 / data.count) + '%'; track.appendChild(fill); track.setAttribute('aria-hidden', 'true');
          row.append(el('span', '', score + ' ★'), track, el('span', '', count.toLocaleString('en'))); distribution.appendChild(row);
        }
        summary.append(aggregate, distribution);
      }
      updateHeader(data);
    }
    function reviewCard(item) {
      var article = el('article', 'hah-reviews__card');
      var header = el('div', 'hah-reviews__card-header'), identity = el('div', 'hah-reviews__identity');
      identity.appendChild(el('strong', '', item.name));
      if (item.verified_purchase === true) identity.appendChild(el('span', 'hah-reviews__verified', 'Verified purchase'));
      var dateValue = [item.display_date, item.published_date, String(item.created_at || '').slice(0, 10)].find(function (value) {
        if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
        var parsed = new Date(value + 'T00:00:00Z');
        return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value;
      });
      if (dateValue) {
        var date = new Date(dateValue + 'T00:00:00Z');
        var time = el('time', 'hah-reviews__date', new Intl.DateTimeFormat('en', { year: 'numeric', month: 'short', day: 'numeric', timeZone: 'UTC' }).format(date));
        time.dateTime = dateValue; header.append(identity, time);
      } else header.appendChild(identity);
      article.append(header, stars(item.rating));
      if (item.title) article.appendChild(el('h3', '', String(item.title)));
      article.appendChild(el('p', 'hah-reviews__body', item.body));
      var photos = el('div', 'hah-reviews__photos');
      item.photos.slice(0, MAX_PHOTOS).forEach(function (value, index) {
        var url = photoUrl(value, apiUrl); if (!url) return;
        var link = el('a'); link.href = url; link.target = '_blank'; link.rel = 'noopener noreferrer';
        link.setAttribute('aria-label', 'Open review photo ' + (index + 1) + ' by ' + item.name);
        var image = el('img'); image.src = url; image.alt = 'Review photo ' + (index + 1) + ' by ' + item.name;
        image.loading = 'lazy'; image.decoding = 'async'; image.width = 120; image.height = 120; image.referrerPolicy = 'no-referrer';
        link.appendChild(image); photos.appendChild(link);
      });
      if (photos.children.length) article.appendChild(photos);
      var reply = typeof item.reply === 'string' ? item.reply : item.reply && (item.reply.body || item.reply.text);
      if (typeof reply === 'string' && reply.trim()) {
        var replyBlock = el('div', 'hah-reviews__reply'); replyBlock.append(el('strong', '', 'Handmade at Heart replied'), el('p', '', reply)); article.appendChild(replyBlock);
      }
      return article;
    }
    function syncPagination() {
      sort.disabled = state.loading;
      previous.disabled = state.loading || state.page <= 1;
      next.disabled = state.loading || state.page >= state.pages;
      pageLabel.textContent = 'Page ' + state.page + ' of ' + Math.max(1, state.pages);
      pagination.hidden = state.pages <= 1;
    }
    async function loadPage(page, scroll) {
      if (state.readController) state.readController.abort();
      var serial = ++state.serial, controller = new AbortController(); state.readController = controller;
      state.loading = true; state.requestedPage = page; list.setAttribute('aria-busy', 'true'); retry.hidden = true; readStatus.classList.remove('is-error');
      readStatus.textContent = 'Loading reviews…'; syncPagination();
      var url = new URL(apiUrl); url.searchParams.set('product_id', productId); url.searchParams.set('page', String(page)); url.searchParams.set('sort', state.sort);
      try {
        var data = validatePage(await request(url.href, {}, 15000, controller));
        if (serial !== state.serial || state.destroyed) return;
        state.page = data.page; state.pages = data.pages;
        renderSummary(data.summary); list.replaceChildren(); data.items.forEach(function (item) { list.appendChild(reviewCard(item)); });
        toolbar.hidden = data.total === 0; totalLabel.textContent = data.total.toLocaleString('en') + (data.total === 1 ? ' review' : ' reviews');
        readStatus.textContent = '';
        if (scroll) { list.scrollIntoView({ behavior: 'smooth', block: 'start' }); list.focus({ preventScroll: true }); }
      } catch (error) {
        if (serial !== state.serial || state.destroyed) return;
        readStatus.textContent = errorMessage(error, 'Reviews could not be loaded. Please try again.'); readStatus.classList.add('is-error'); retry.hidden = false;
      } finally {
        if (serial === state.serial && !state.destroyed) { state.loading = false; list.setAttribute('aria-busy', 'false'); syncPagination(); }
      }
    }
    function renderPreviews() {
      previews.replaceChildren();
      state.photos.forEach(function (photo, index) {
        var figure = el('div', 'hah-reviews__photo-preview');
        var image = el('img'); image.src = photo.data_url; image.alt = 'Selected review photo ' + (index + 1); image.width = 100; image.height = 100;
        var remove = button('Remove', 'hah-reviews__photo-remove'); remove.setAttribute('aria-label', 'Remove review photo ' + (index + 1));
        remove.addEventListener('click', function () { if (state.processing || state.submitting) return; state.photos.splice(index, 1); renderPreviews(); syncForm(); });
        figure.append(image, remove); previews.appendChild(figure);
      });
    }
    file.addEventListener('change', async function () {
      if (state.processing || state.submitting) return;
      var files = Array.from(file.files || []); file.value = '';
      if (!files.length) return;
      if (files.length + state.photos.length > MAX_PHOTOS) { formMessage('You can add up to 3 photos. Please choose fewer photos.', true); return; }
      state.processing = true; syncForm(); formMessage('Preparing your photos…', false);
      try {
        var prepared = [];
        for (var source of files) prepared.push(await compressPhoto(source));
        if (state.destroyed) return;
        state.photos = state.photos.concat(prepared); renderPreviews(); formMessage('Photos are ready.', false);
      } catch (error) { if (!state.destroyed) formMessage(errorMessage(error, 'Photos could not be prepared. Please try again.'), true); }
      finally { state.processing = false; if (!state.destroyed) syncForm(); }
    });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (state.processing || state.submitting || state.submitted || !form.reportValidity()) return;
      var selectedRating = form.querySelector('[name="rating"]:checked');
      if (!selectedRating) return;
      if (!name.value.trim() || !body.value.trim()) { formMessage('Please enter your name and review.', true); return; }
      var payload = { product_id: productId, name: name.value.trim(), email: email.value.trim(), rating: Number(selectedRating.value), title: title.value.trim(), body: body.value.trim(), photos: state.photos, website: website.value };
      if (invitationToken) payload.invitation_token = invitationToken;
      var signature = JSON.stringify(payload);
      if (signature !== state.signature) { state.signature = signature; state.key = key(); }
      payload.idempotency_key = state.key;
      state.submitting = true; state.postController = new AbortController(); syncForm(); formMessage('Submitting your review…', false);
      try {
        var data = await request(apiUrl.href, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) }, 30000, state.postController);
        if (state.destroyed) return;
        if (!data || data.status !== 'pending' || !data.id) throw new Error('We could not confirm your submission. Please retry; your review will not be duplicated.');
        state.submitted = true; form.hidden = true; intro.hidden = true; confirmation.hidden = false;
        confirmation.append(el('strong', '', 'Thank you for sharing your experience.'), el('p', '', 'Your review was received and is awaiting review before publication.'));
        writeButton.textContent = 'Review submitted'; writeButton.disabled = true;
        state.photos = []; renderPreviews(); form.reset(); formMessage('', false);
        // Pending submissions never change public counts, averages, or review cards.
      } catch (error) {
        if (!state.destroyed) formMessage(errorMessage(error, 'Your review could not be submitted. Please try again.') + ' You can retry safely with the same details.', true);
      } finally { state.submitting = false; if (!state.destroyed) syncForm(); }
    });
    writeButton.addEventListener('click', function () { openForm(true); });
    cancel.addEventListener('click', function () { if (!state.processing && !state.submitting) { formPanel.hidden = true; writeButton.focus(); } });
    sort.addEventListener('change', function () { state.sort = sort.value; loadPage(1, false); });
    previous.addEventListener('click', function () { if (!state.loading && state.page > 1) loadPage(state.page - 1, true); });
    next.addEventListener('click', function () { if (!state.loading && state.page < state.pages) loadPage(state.page + 1, true); });
    retry.addEventListener('click', function () { loadPage(state.requestedPage, false); });
    root.hahReviewsDestroy = function () { state.destroyed = true; ++state.serial; if (state.readController) state.readController.abort(); if (state.postController) state.postController.abort(); };
    if (invitationToken && window.location.hash === anchor) openForm(false);
    loadPage(1, false);
  }
  function mountAll(scope) {
    if (scope.matches && scope.matches('[data-hah-reviews]')) mount(scope);
    scope.querySelectorAll('[data-hah-reviews]').forEach(mount);
  }
  window.HahReviews = { mountAll: mountAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mountAll(document); });
  else mountAll(document);
  document.addEventListener('shopify:section:load', function (event) { mountAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.matches('[data-hah-reviews]') ? [event.target] : event.target.querySelectorAll('[data-hah-reviews]');
    Array.from(roots).forEach(function (root) { if (root.hahReviewsDestroy) root.hahReviewsDestroy(); });
  });
}());
